export const TOGGLE_SEARCH_SIDEBAR_VISIBILITY = 'globalSearch/TOGGLE_SEARCH_BAR_VISIBILITY';
export const ADD_SEARCH_TERM = 'globalSearch/ADD_SEARCH_TERM';
export const ADD_RECENT_SEARCH = 'globalSearch/ADD_RECENT_SEARCH';
export const ADD_SEARCH_RESULTS = 'globalSearch/ADD_SEARCH_RESULTS';
export const OVERRIDE_RECENT_SEARCHES = 'globalSearch/OVERRIDE_RECENT_SEARCHES';
export const DELETE_ALL_RECENT_SEARCHES = 'globalSearch/DELETE_ALL_RECENT_SEARCHES';
